<template>
  <div class="bigBox container">
    <div class="box" v-html="contentText"></div>
    <div class="emptyBox"></div>
    <div class="btn-main">
      <button class="agreen-btn" @click="$router.go(-1)">我知道了</button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AccountCancellationNotice',
  data() {
    return {
      contentText: `
          <h3 style='text-align: center;'>搜货精选注销须知</h3>
          <br>
          亲爱的搜货精选用户：<br>
          <div style="text-indent: 2em">在您确认注销您的搜货精选平台账户之前，请您充分阅读、理解并同意《搜货精选注销须知》（以下简称“须知”），特别是以粗体下划线标注的内容。如您不同意下列任一内容，或无法准确理解任何条款的含义，请不要进行账户注销操作。您通过搜货精选指定的页面确认申请注销，视为您同意接受本须知内的所有内容。<strong style="text-decoration: underline">我们在此善意地提醒您，您注销账户的行为会给您继续使用搜货精选带来诸多不便和影响。</strong></div>
          <br>
          1、<strong style="text-decoration: underline">您所申请注销的搜货精选账户应当是您依照与搜货精选的约定注册并由搜货精选提供给您本人的账户。</strong>您自注册该账户起，使用该账户进行的行为符合国家法律法规、《搜货精选用户服务协议》以及其他搜货精选公开发布的规则要求。<br>
          <br>
          2、<strong style="text-decoration: underline">您应确保您有权决定本账户的注销事宜，</strong>不侵犯任何第三方的合法权益，如因此引发任何投诉或争议，由您自行承担并使搜货精选免责。<br>
          <br>
          3、<strong style="text-decoration: underline">搜货精选账户一旦被注销将不可恢复，</strong>请您在操作之前自行备份搜货精选账户相关的所有信息和数据。<br>
          <br>
          4、如果您仍执意注销账户，您的账户需同时满足以下条件：
          <br>
          <div style="text-indent: 2em">1)  账户无异常行为记录，且账户信息无相关注销记录；<br></div>
          <div style="text-indent: 2em">2)  自愿放弃账户在搜货精选平台账户中的资产和虚拟权益；<br></div>
          <div style="text-indent: 2em">3)  账户内不存在未完成的订单；<br></div>
          <div style="text-indent: 2em">4)  账户处于正常使用状态，没有被限制使用；<br></div>
          <div style="text-indent: 2em">5)  其他账户注销条件（具体以搜货精选实际要求和审核为准）。</div>
          <br>
          5、在搜货精选账户注销期间，如果您的搜货精选账户涉及争议纠纷，包括但不限于投诉、举报、诉讼、仲裁、国家有权机关调查等，搜货精选有权自行终止本搜货精选账户的注销而无需另行得到您的同意。<br>
          <br>    
          6、您充分知晓搜货精选账户注销将导致搜货精选为您终止提供服务,《搜货精选用户服务协议》约定的双方权利义务终止(依本须知其他条款另行约定不得终止的或依其性质不能终止的除外)，同时还可能对于本账户产生包括但不限于如下结果:
          <br> 
          <div style="text-indent: 2em">1)  <strong style="text-decoration: underline">该账号将无法登录、使用搜货精选平台（包括微信公众号网页和APP），并移除该账号下所有登录方式；</strong><br></div>
          <div style="text-indent: 2em">2)  账号中已有和待领取的免单卡以及其他权益将无法使用；<br></div>
          <div style="text-indent: 2em">3)  移除该账号下的实名认证信息；<br></div>
          <div style="text-indent: 2em">4)  该账号下的个人资料和订单信息都将无法找回；<br></div>
          <div style="text-indent: 2em">5)  <strong style="text-decoration: underline">出于平台数据考虑，当前注销手机号将无法再次注册搜货精选平台账号。</strong><br></div>
          <br>
          7、您应当按照搜货精选页面展示的流程进行账户注销，<strong style="text-decoration: underline">且您承诺该账户注销申请一经提交，您不会以任何理由要求搜货精选予以撤销。</strong><br>
          <br>
          8、<strong style="text-decoration: underline">注销本搜货精选账户并不代表本搜货精选账户注销前的账户行为和相关责任得到豁免或减轻。</strong><br>
          <br>
          9、本注销须知未尽事宜，搜货精选依照与您约定的《搜货精选用户服务协议》执行。
          `
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  background: #fff;
}
@import './css/index.scss';
</style>
